import { ProductionDetails } from '@/modals/production/ProductionDetails';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { EncryptionService } from '@services/encryption.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-production',
  templateUrl: './production.component.html',
  styleUrls: ['./production.component.scss']
})
export class ProductionComponent implements OnInit {

  productions: ProductionDetails[] = [];
  encryptedId: string | null = null;
  router: Router;

  constructor(
    private appService: AppService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    router: Router,
    private route: ActivatedRoute,
    private encryptionService: EncryptionService
  ) {
    this.router = router;
  }

  ngOnInit(): void {
    const encryptedIdParam = this.route.snapshot.paramMap.get('id');
    this.encryptedId = encryptedIdParam;

    if (encryptedIdParam) {
      try {
        const decryptedId = this.encryptionService.decrypt(decodeURIComponent(encryptedIdParam));
        this.loadProductionDetail(Number(decryptedId));
      } catch (error) {
        console.error('Error decrypting production ID:', error);
        this.getAllProductionDetails();
      }
    } else {
      this.getAllProductionDetails();
    }
  }

  getAllProductionDetails() {
    this.spinner.show();
    this.appService.getAllProductions().subscribe({
      next: (data) => {
        this.productions = data.sort(
          (a: any, b: any) => b.auditionCallRegSeq - a.auditionCallRegSeq
        );
      },
      error: (err) => {
        console.error('Error loading Productions:', err);
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }

  loadProductionDetail(productionId: number): void {
    this.spinner.show();
    this.appService.getAllProductions().subscribe({
      next: (data) => {
        const production = data.find(p => p.auditionCallRegSeq === productionId);
        if (production) {
          this.productions = [production];
        } else {
          this.toastr.error('Production not found');
          this.router.navigate(['/main/production']);
        }
      },
      error: (err) => {
        console.error('Error loading production detail:', err);
        this.toastr.error('Unable to load production details');
        this.router.navigate(['/main/production']);
      },
      complete: () => {
        setTimeout(() => this.spinner.hide(), 2000);
      },
    });
  }

  viewProduction(productionDetailsId: number): void {
    const encryptedId = this.encryptionService.encrypt(productionDetailsId.toString());
    this.router.navigate(['/main/production', encodeURIComponent(encryptedId)]);
  }

  downloadVideo(auditionCallRegSeq: number) {
    this.spinner.show();
    this.appService.downloadPerformanceVideo(auditionCallRegSeq).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `performance-video-${auditionCallRegSeq}.mp4`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        this.spinner.hide();
        this.toastr.success('Video downloaded successfully');
      },
      error: (err) => {
        console.error('Download failed:', err);
        this.toastr.error('Failed to download video');
        this.spinner.hide();
      }
    });
  }
}
